import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect, tabulation } from "@/mixins/index";
import Events from "./mixins/Events";
import { eventActionFunnel } from "@/api/dataAll/retentionAnalysis";
import { customPlayerList } from "@/api/customizationEvents/customizationEvents";
import * as echarts from "echarts";
export default {
  name: "timeFunnel",
  mixins: [serchSelect, tabulation, Events],
  data: function data() {
    return {
      // more:true,
      value2: [],
      searchData: {
        begin_date: '',
        end_date: '',
        // country: '',
        begin_action: '',
        // retain_action: '',
        retain_days: 5,
        dimensionField: 'user_id',
        ad_id: ''
      },
      behaviorList: [],
      analyzetypeList: [{
        label: this.$t('userId'),
        value: 'user_id'
      }, {
        label: this.$t('deviceId'),
        value: 'device_id'
      }],
      tableDataTow: [],
      eventList: [{
        begin_action: ''
      }, {
        begin_action: ''
      }],
      currentMetric: 'count',
      // 当前显示的指标: 'count' 或 'percentage'
      echartInstance: null,
      tableNewData: []
    };
  },
  created: function created() {
    this.getcustomEventList();
  },
  activated: function activated() {},
  computed: {
    // 动态生成表头配置
    tableColumns: function tableColumns() {
      if (!this.tableData || this.tableData.length === 0) return [];
      return this.tableData.map(function (item) {
        return {
          label: item.event_name || item.name,
          // 优先显示处理好的中文名
          prop: item.name // 使用唯一的事件英文标识作为 prop

        };
      });
    }
  },
  methods: {
    addActionItem: function addActionItem() {
      if (this.eventList.length >= 5) {
        this.$message.warning(this.$t('maxAddEvents'));
        return;
      }

      this.eventList.push({
        begin_action: this.searchData.begin_action
      });
    },

    /**
     * 删除事件项
     */
    removeActionItem: function removeActionItem(index) {
      if (this.eventList.length <= 2) {
        this.$message.warning(this.$t('minKeepEvents'));
        return;
      }

      this.eventList.splice(index, 1);
    },

    /**
     * 
     *  自定义事件表相关
     * */
    getcustomEventList: function getcustomEventList() {
      var _this = this;

      customPlayerList({
        game_id: this.rawData.game_id
      }).then(function (res) {
        if (res.status == 200) {
          _this.tableDataTow = res.data;
          _this.behaviorList = [];
          res.data.forEach(function (i) {
            var data = {
              label: i.event_name,
              value: i.event,
              disabled: false
            };

            _this.behaviorList.push(_objectSpread({}, data));
          });
          _this.searchData.begin_action = res.data[0] ? res.data[0].event : ''; // this.searchData.retain_action = res.data[1] ? res.data[1].event : res.data[0] ? res.data[0].event : ''

          _this.eventList[0].begin_action = _this.searchData.begin_action;
          _this.eventList[1].begin_action = _this.searchData.begin_action;
        }
      });
    },
    searchList: function searchList() {
      var _this2 = this;

      this.searchData.start_date = this.value2[0];
      this.searchData.end_date = this.value2[1];
      var paramsData = JSON.parse(JSON.stringify(this.searchData));
      paramsData.type = 'player';
      paramsData.events = this.eventList.map(function (item) {
        return item.begin_action;
      });
      this.loadingBtn = true;
      eventActionFunnel(paramsData).then(function (res) {
        if (res.status == 200) {
          var rawFunnelData = res.data.funnel_data || []; // 1. 获取名称映射

          var eventMap = {};

          _this2.behaviorList.forEach(function (b) {
            eventMap[b.value] = b.label;
          }); // 2. 预处理 tableData（用于 Echarts 和 Computed 表头生成）


          _this2.tableData = rawFunnelData.map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              event_name: eventMap[item.name]
            });
          }); // 3. 构建表格行数据：直接在这里处理，不要再调用旧的 buildTableData

          var dataRow = {};

          _this2.tableData.forEach(function (item) {
            // 重要：这里的键名必须是 item.name，才能和 computed 里的 prop 对应上
            dataRow[item.name] = {
              count: item.count,
              percentage: item.percentage
            };
          });

          _this2.tableNewData = [dataRow];
          console.log("this.tableNewData==", _this2.tableNewData);
          console.log("this.tableData==", _this2.tableData);

          _this2.$nextTick(function () {
            _this2.getechart();
          });
        }
      }).finally(function () {
        _this2.loadingBtn = false;
      });
    },
    onMetricChange: function onMetricChange(value) {
      this.currentMetric = value;
      this.getechart(); // 重新渲染图表
    },
    getechart: function getechart() {
      var _this3 = this;

      if (!this.tableData || this.tableData.length === 0) {
        return;
      }

      var chartDom = document.getElementById("playTimeFunnelEchart");
      if (!chartDom) return; // 如果已存在实例，先销毁

      if (this.echartInstance) {
        this.echartInstance.dispose();
      }

      var myChart = echarts.init(chartDom);
      this.echartInstance = myChart; // 准备数据

      var categories = this.tableData.map(function (item) {
        return item.event_name;
      });
      var countData = this.tableData.map(function (item) {
        return item.count;
      });
      var percentageData = this.tableData.map(function (item) {
        return parseFloat(item.percentage) || 0;
      }); // 当前显示的指标类型 ('count' 或 'percentage')

      var currentMetric = this.currentMetric || 'count'; // 配置选项

      var option = {
        title: {
          text: this.$t('playTimeFunnelAnalysis'),
          left: 'center',
          top: 10,
          textStyle: {
            fontSize: 16,
            fontWeight: 'normal'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function (params) {
            if (!params || params.length === 0) return '';
            var dataIndex = params[0].dataIndex;
            var eventName = categories[dataIndex];
            var count = countData[dataIndex];
            var percentage = percentageData[dataIndex];
            return "\n              <div style=\"font-weight: bold; margin-bottom: 5px;\">".concat(eventName, "</div>\n              <div>").concat(this.$t('countLabel'), " ").concat(count, "</div>\n              <div>").concat(this.$t('percentageLabel'), " ").concat(percentage, "%</div>\n            ");
          }.bind(this)
        },
        legend: {
          data: currentMetric === 'count' ? [this.$t('personCount')] : [this.$t('percentageWithSymbol')],
          left: 'left',
          top: 30,
          selectedMode: 'single'
        },
        grid: {
          left: '8%',
          right: '8%',
          bottom: '8%',
          top: '18%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: categories,
          name: this.$t('eventName'),
          nameLocation: 'middle',
          nameGap: 35,
          axisLabel: {
            rotate: categories.length > 6 ? 25 : 0,
            interval: 0,
            fontSize: 12,
            formatter: function formatter(value) {
              if (value.length > 10) {
                return value.substring(0, 8) + '...';
              }

              return value;
            }
          },
          axisLine: {
            lineStyle: {
              color: '#999'
            }
          }
        },
        yAxis: {
          type: 'value',
          name: currentMetric === 'count' ? this.$t('personCount') : this.$t('percentageWithSpace'),
          nameLocation: 'middle',
          nameGap: 45,
          axisLabel: {
            fontSize: 12
          },
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        series: [{
          name: currentMetric === 'count' ? this.$t('personCount') : this.$t('percentageWithSymbol'),
          type: 'line',
          data: currentMetric === 'count' ? countData : percentageData,
          smooth: true,
          symbol: 'circle',
          symbolSize: 8,
          lineStyle: {
            width: 3,
            color: '#4f74ff',
            shadowBlur: 10,
            shadowColor: 'rgba(79, 116, 255, 0.3)'
          },
          itemStyle: {
            color: '#4f74ff',
            borderColor: '#fff',
            borderWidth: 2
          },
          label: {
            show: true,
            position: 'top',
            formatter: function formatter(params) {
              if (currentMetric === 'count') {
                return params.value;
              } else {
                return params.value.toFixed(2) + '%';
              }
            },
            fontSize: 12,
            fontWeight: 'bold',
            color: '#333'
          },
          emphasis: {
            focus: 'series',
            scale: true
          }
        }],
        // 添加数据缩放组件，方便查看大量数据
        dataZoom: categories.length > 10 ? [{
          type: 'slider',
          start: 0,
          end: 100,
          bottom: 20
        }, {
          type: 'inside',
          start: 0,
          end: 100
        }] : []
      };
      myChart.setOption(option); // 窗口自适应

      window.addEventListener('resize', function () {
        if (_this3.echartInstance) {
          _this3.echartInstance.resize();
        }
      });
    }
  }
};